import { render, staticRenderFns } from "./OrdersFBMBlock.vue?vue&type=template&id=47f07630&scoped=true"
import script from "./OrdersFBMBlock.vue?vue&type=script&lang=js"
export * from "./OrdersFBMBlock.vue?vue&type=script&lang=js"
import style0 from "./OrdersFBMBlock.vue?vue&type=style&index=0&id=47f07630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f07630",
  null
  
)

export default component.exports